import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useProductMe } from "../hooks/useProductMe.js";

export default function ProtectedOutlet() {
  const location = useLocation();
  const { me, loading } = useProductMe();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "var(--bg-base)",
          color: "var(--text-secondary)",
        }}
      >
        Loading…
      </div>
    );
  }

  if (!me?.authenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
